export type WizardStep = "step-collect" | "step-booking" | "step-install"

// IMP-461: the reduced guide — the assistant builds the chat bot from the
// business profile and brand (building beat), then two consequence-framed
// decisions (take messages, book appointments) and the install
// step with the copyable snippet. Appearance derives from the scraped brand;
// placement defaults to bottom-right and is editable from the drawer.
export const STEP_ORDER: WizardStep[] = [
  "step-collect",
  "step-booking",
  "step-install",
]

export const STEP_TITLE: Record<WizardStep, string> = {
  "step-collect": "Messages",
  "step-booking": "Appointments",
  "step-install": "Install",
}

// Legacy keys from the pre-IMP-461 wizard resume at the nearest survivor.
const LEGACY_STEP_MAP: Record<string, WizardStep> = {
  "step-appearance": "step-collect",
  "step-behavior": "step-collect",
  "step-conversions": "step-booking",
  "step-customization": "step-install",
}

export function stepFor(raw: string | null | undefined): WizardStep {
  if (STEP_ORDER.includes(raw as WizardStep)) return raw as WizardStep
  return LEGACY_STEP_MAP[raw ?? ""] ?? "step-collect"
}
